export default __webpack_public_path__ + "static/media/espetr8.f7ecb903.svg";